export class PrintWindowBlockedError extends Error {
	constructor() {
		super('Unable to open receipt print window');
	}
}

export type HtmlSanitizer = (html: string) => string;

export const printHtml = (html: string, sanitize: HtmlSanitizer): void => {
	const printWindow = window.open('', '_blank');

	if (!printWindow) {
		throw new PrintWindowBlockedError();
	}

	printWindow.document.open();
	printWindow.document.writeln(sanitize(html));
	printWindow.document.close();
};
